import { Injectable } from '@angular/core';

/**
 * 通信中に操作を禁止する為の機能を提供するサービス
 */
@Injectable()
export class PlessBlockLayerService {

    constructor() {}

    private blockLayer: HTMLElement;
    private blockLayerCount = 0;

    /**
     * 操作を禁止する為の透明なレイヤーを画面に追加する
     */
    createBlockLayer() {
        if (this.blockLayerCount === 0) {
            if (!this.blockLayer) {
                this.blockLayer = document.createElement('div');
                this.blockLayer.style.top = '0';
                this.blockLayer.style.bottom = '0';
                this.blockLayer.style.left = '0';
                this.blockLayer.style.right = '0';
                this.blockLayer.style.position = 'fixed';
                this.blockLayer.style.zIndex = '2147483647';
                // 通信中はマウスカーソルを処理中カーソルに変更
                this.blockLayer.style.cursor = 'wait';
                /*
                // 通信中を示すローディング画像を追加
                const loadingIcon = document.createElement('IMG');
                loadingIcon.style.top = '0';
                loadingIcon.style.bottom = '0';
                loadingIcon.style.left = '0';
                loadingIcon.style.right = '0';
                loadingIcon.style.margin = 'auto';
                loadingIcon.style.position = 'fixed';
                loadingIcon.setAttribute('src', '../../assets/loading.gif');
                this.blockLayer.appendChild(loadingIcon);
                */
            }
            document.body.appendChild(this.blockLayer);
            // キーイベントを無効化
            window.addEventListener('keydown', this.handleKeyDown);
        }
        this.blockLayerCount++;
    }

    /**
     * 操作を禁止する為のレイヤーを画面から削除する
     */
    removeBlockLayer() {
        this.blockLayerCount--;
        if (this.blockLayerCount <= 0) {
            document.body.removeChild(this.blockLayer);
            window.removeEventListener('keydown', this.handleKeyDown);
            this.blockLayerCount = 0;   // マイナスになる事はないが、念の為...
        }
    }

    /**
     * キーイベントを無効化するイベントハンドラ.
     *
     * @param event キーダウンイベント
     */
    private handleKeyDown(event: KeyboardEvent) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }

}
